export default {
    fileUpload: {
        clickToUpload: "Haz clic para subir",
        andAttachFiles: "y adjunta archivos",
        orDragAndDrop: "o arrastra y suelta",
        defaultHint: "SVG, PNG, JPG o GIF (máx. 800x400px)",
        complete: "Completado",
        uploading: "Subiendo...",
        failed: "Fallido",
        delete: "Eliminar",
        retry: "Reintentar",
        tryAgain: "Intentar de nuevo",
        uploadFailed: "Error al subir, por favor intenta de nuevo",
        dragAndDrop: "o arrastra y suelta",
        maxFileSize: "Tamaño máximo: {{size}}",
        acceptedFormats: "Formatos aceptados: {{formats}}",
        uploadSuccess: "Archivo subido con éxito",
        uploadError: "Error al subir el archivo",
    },
    commandMenu: {
        title: "Menú de Comandos",
        searchPlaceholder: "Buscar...",
        removeFilter: "Quitar filtro",
        noResults: "No se encontraron resultados",
        startTyping: "Comienza a escribir para buscar...",
        entities: {
            container: "Contenedor",
            sender: "Remitente",
            receiver: "Destinatario",
            account: "Cuenta",
            address: "Libreta de Direcciones",
            document: "Documentos",
        },
    },
    aiChat: {
        title: "Pregunta a Eve",
        placeholder: "Pregunta a Eve...",
        ariaLabel: "Chat IA",
        welcome: "Hola, ¿cómo puedo ayudarte?",
        welcomeSubtitle: "Elige una acción para comenzar",
        actions: {
            createContainer: "Crear Contenedor",
            createOrder: "Crear Pedido",
            createQuoteRequest: "Crear Solicitud de Cotización",
            createQuote: "Crear Cotización",
        },
        you: "Tú",
        assistant: "Asistente",
        attach: "Adjuntar",
        emoji: "Emoji",
        newChat: "Nueva chat",
        chatHistory: "Historial de chat",
        noChats: "Aún no hay chats",
        deleteChat: "Eliminar chat",
        confirmDelete: "¿Estás seguro de que quieres eliminar esta chat?",
        renameChat: "Renombrar chat",
        chatTitle: "Título de chat",
        saveTitle: "Guardar título",
        editTitle: "Editar título",
        wizard: {
            confirmed: "¡Perfecto! Continuemos...",
            enterValue: "Ingresa el valor...",
            create: "Crear",
            cancelled: "Wizard cancelado. ¿Cómo puedo ayudarte?",
            notSpecified: "No especificado",
            container: {
                containerNumber: "¿Cuál es el número del contenedor?",
                routeFrom: "¿Desde qué ciudad parte el contenedor?",
                routeTo: "¿Hacia qué ciudad va el contenedor?",
                eta: "¿Cuál es la fecha de llegada prevista (ETA)?",
                valueAmount: "¿Cuál es el valor del contenedor?",
                valueCurrency: "¿Qué moneda quieres usar?",
                status: "¿Cuál es el estado del contenedor?",
                receiverId: "¿Qué receptor quieres seleccionar?",
                shippingCompany: "¿Qué compañía de envío? (opcional)",
                review: "Resumen:\n- Número de Contenedor: {{containerNumber}}\n- Desde: {{routeFrom}}\n- Hacia: {{routeTo}}\n- ETA: {{eta}}\n- Valor: {{valueAmount}} {{valueCurrency}}\n- Estado: {{status}}\n- Receptor: {{receiver}}\n- Compañía de Envío: {{shippingCompany}}",
                success: "¡Contenedor creado con éxito!",
                completed: "¡Contenedor creado! Redirigiendo...",
            },
            order: {
                shipperId: "¿Qué expedidor quieres seleccionar?",
                targetDate: "¿Cuál es la fecha objetivo para el pedido?",
                packingListRequested: "¿Qué detalles quieres en la lista de empaque?",
                notes: "Notas adicionales (opcional):",
                review: "Resumen:\n- Expedidor: {{shipper}}\n- Fecha Objetivo: {{targetDate}}\n- Lista de Empaque: {{packingList}}\n- Notas: {{notes}}",
                success: "¡Pedido creado con éxito!",
                completed: "¡Pedido creado! Redirigiendo...",
            },
            quoteRequest: {
                subject: "¿Cuál es el asunto de la solicitud de cotización?",
                body: "Ingresa el texto de la solicitud de cotización:",
                recipients: "Selecciona los transitarios destinatarios:",
                review: "Resumen:\n- Asunto: {{subject}}\n- Cuerpo: {{body}}\n- Destinatarios: {{recipients}}",
                success: "¡Solicitud de cotización creada con éxito!",
                completed: "¡Solicitud creada! Redirigiendo...",
            },
            quoteResponse: {
                selectQuote: "¿A qué solicitud de cotización quieres responder?",
                usingContext: "Estoy respondiendo a la solicitud: {{subject}}",
                responseSubject: "¿Cuál es el asunto de la respuesta?",
                responseBody: "Ingresa el texto de la respuesta:",
                review: "Resumen:\n- Solicitud: {{quoteSubject}}\n- Asunto de Respuesta: {{responseSubject}}\n- Cuerpo de Respuesta: {{responseBody}}",
                success: "¡Cotización creada con éxito!",
                completed: "¡Cotización creada! Redirigiendo...",
            },
        },
    },
    stats: {
        vsLastMonth: "vs mes pasado",
    },
    buttons: {
        submit: "Enviar",
        cancel: "Cancelar",
        save: "Guardar",
        delete: "Eliminar",
        edit: "Editar",
        create: "Crear",
        update: "Actualizar",
        add: "Añadir",
        remove: "Quitar",
        close: "Cerrar",
        back: "Atrás",
        next: "Siguiente",
        previous: "Anterior",
        confirm: "Confirmar",
        logout: "Cerrar sesión",
        login: "Iniciar sesión",
        reset: "Restablecer",
        search: "Buscar",
        filter: "Filtrar",
        clear: "Limpiar",
        apply: "Aplicar",
        upload: "Subir",
        download: "Descargar",
        view: "Ver",
        share: "Compartir",
        send: "Enviar",
        invite: "Invitar",
        accept: "Aceptar",
        reject: "Rechazar",
    },
    form: {
        required: "Campo obligatorio",
        optional: "Opcional",
        invalid: "Valor no válido",
        emailInvalid: "Dirección de email no válida",
        passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
        selectPlaceholder: "Selecciona una opción...",
        searchPlaceholder: "Buscar...",
        noResults: "No se encontraron resultados",
        loading: "Cargando...",
        errors: {
            allFieldsRequired: "Todos los campos son obligatorios",
            amountInvalid: "El importe debe ser un número mayor que 0",
        },
    },
    validation: {
        required: "Este campo es obligatorio",
        email: "Por favor ingresa una dirección de email válida",
        minLength: "Debe tener al menos {{count}} caracteres",
        maxLength: "Debe tener como máximo {{count}} caracteres",
        pattern: "Formato no válido",
    },
    errors: {
        generic: "Ocurrió un error",
        network: "Error de red. Por favor intenta de nuevo.",
        unauthorized: "Acceso no autorizado",
        notFound: "Recurso no encontrado",
        serverError: "Error del servidor. Por favor intenta más tarde.",
        unknown: "Error desconocido",
    },
    messages: {
        success: "Operación completada con éxito",
        saved: "Guardado con éxito",
        deleted: "Eliminado con éxito",
        created: "Creado con éxito",
        updated: "Actualizado con éxito",
        loading: "Cargando...",
        noData: "No hay datos disponibles",
        confirmDelete: "¿Estás seguro de que quieres eliminar este elemento?",
    },
    date: {
        today: "Hoy",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        thisWeek: "Esta semana",
        thisMonth: "Este mes",
        thisYear: "Este año",
    },
    language: "Idioma",
    changeLanguage: "Cambiar idioma",
    english: "English",
    italiano: "Italiano",
    español: "Español",
    pdfViewer: {
        prev: "Ant",
        next: "Sig",
        page: "Página",
        addRectangle: "Añadir Rectángulo",
        addRectangleHere: "Añadir rectángulo aquí",
        loadingPdf: "Cargando PDF...",
    },
    signOut: {
        confirm: {
            title: "Confirmar Cierre de Sesión",
            message: "¿Estás seguro de que quieres cerrar sesión? Necesitarás iniciar sesión nuevamente para usar la aplicación.",
        },
    },
    accountSwitch: {
        switching: "Cambiando cuenta...",
    },
    orderAccept: {
        confirmCreateQuotes: {
            title: "Crear solicitudes de cotización",
            message: "¿Quieres crear automáticamente las solicitudes de cotización basadas en las especificaciones de este pedido?",
            createQuotes: "Sí, crear solicitudes",
            acceptOnly: "No, aceptar solo el pedido",
        },
        creatingQuotes: "Creando solicitudes de cotización",
    },
    theme: "Tema",
    themeLight: "Claro",
    themeDark: "Oscuro",
    themeSystem: "Sistema",
};

